const STORAGE_PREFIX = 'fcs-ticket-state-';

/**
 * @param {number} eventId
 * @returns {string}
 */
function getStorageKey(eventId) {
  return `${STORAGE_PREFIX}${eventId}`;
}

/**
 * @param {number} eventId
 * @returns {{ showModal: boolean; isForYou: number; tickets: Array }}
 */
export function loadTicketState(eventId) {
  if (!eventId) return null;
  try {
    const raw = localStorage.getItem(getStorageKey(eventId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      showModal: Boolean(parsed.showModal),
      isForYou: Number(parsed.isForYou) || 0,
      tickets: Array.isArray(parsed.tickets) ? parsed.tickets : [],
    };
  } catch {
    return null;
  }
}

/**
 * @param {number} eventId
 * @param {{ showModal?: boolean; isForYou?: number; tickets?: Array }} state
 */
export function saveTicketState(eventId, state) {
  if (!eventId) return;
  try {
    const existing = loadTicketState(eventId) || {};
    const merged = { ...existing, ...state };
    localStorage.setItem(getStorageKey(eventId), JSON.stringify(merged));
  } catch {
    // Ignore storage errors (e.g. private mode)
  }
}

/**
 * Clear ticket state for an event (e.g. after successful add to cart).
 * @param {number} eventId
 */
export function clearTicketState(eventId) {
  if (!eventId) return;
  try {
    localStorage.removeItem(getStorageKey(eventId));
  } catch {
    // Ignore storage errors
  }
}
